import { View, StyleSheet } from "react-native";
import Text from "src/common/components/text";
import { Image } from "src/common/components/image";
import Constants from "expo-constants";

import Button from "./button";
import { ImageMapper } from "src/common/assets/images";
import { ReactNode } from "react";
import { useNavigation } from "@react-navigation/native";
import translate from "libs/locale";
import Animated from "react-native-reanimated";
import { Shadow } from "react-native-shadow-2";

type RightViewText = {
  title?: string;
  subTitle?: string;
};

function isRightViewText(obj: any): obj is RightViewText {
  return "title" in obj || "subTitle" in obj;
}

const Header = ({
  onMenu,
  name,
  subText,
  style,
  back,
  backNoText,
  onBack,
  rightView,
  leftView,
  shadowDistanceStyle = { opacity: 0 },
}: {
  name?: string;
  subText?: string;
  style?: object;
  back?: boolean;
  backNoText?: boolean;
  shadowDistanceStyle?: object;
  rightView?: (() => React.JSX.Element) | RightViewText | React.JSX.Element;
  onBack?: () => void;
  onMenu?: () => void;
  leftView?: () => React.JSX.Element | React.JSX.Element;
}) => {
  const navigation = useNavigation();
  const extras = Constants.expoConfig?.extra;
  const client = extras?.client || process.env.CLIENT;

  const getBack = () => {
    return (
      <Button
        onPress={onBack || navigation.goBack}
        style={styles.buttonLogin}
        solid={false}
      >
        {<Image source={ImageMapper.Back} style={styles.backIcon} />}
        {!backNoText && (
          <Text
            style={[
              styles.back,
              client === "merchant" && { color: "#364650", fontSize: 20 },
            ]}
          >
            {translate("back")}
          </Text>
        )}
      </Button>
    );
  };

  const getMenu = () => {
    return (
      <Button
        onPress={onMenu}
        style={[styles.buttonLogin, styles.menuContainer]}
        solid={false}
      >
        {<Image source={ImageMapper.Menu} style={styles.menuIcon} />}
      </Button>
    );
  };

  const getRightView = () => {
    if (rightView && isRightViewText(rightView)) {
      return (
        <View style={styles.headerContent}>
          {!!rightView.title && (
            <Text style={[styles.name, styles.nameHeader]}>
              {rightView.title}
            </Text>
          )}
          {!!rightView.subTitle && (
            <Text style={styles.city}>{rightView.subTitle}</Text>
          )}
        </View>
      );
    } else if (rightView && typeof rightView === "function") {
      return rightView() as ReactNode;
    }
    return null;
  };

  const getLeftView = () => {
    return leftView();
  };

  return (
    <>
      <View style={styles.root}>
        {leftView && getLeftView()}
        {back || backNoText ? getBack() : <View style={styles.buttonLogin} />}
        {onMenu && getMenu()}
        <View style={styles.container}>
          <Text
            style={[
              styles.title,
              client === "merchant" && { color: "#364650" },
              ,
              style,
            ]}
            numberOfLines={1}
          >
            {name}
          </Text>
          {subText && <Text style={styles.subText}>{subText}</Text>}
        </View>
        {getRightView()}
      </View>
      <Animated.View
        style={[
          shadowDistanceStyle,
          { position: "absolute", left: 0, right: 0, top: 64, zIndex: 1 },
        ]}
      >
        <Shadow distance={10} offset={[0, -2]} style={{ alignSelf: "auto" }}>
          <View style={[styles.animatedContainer]} />
        </Shadow>
      </Animated.View>
    </>
  );
};

const styles = StyleSheet.create({
  root: {
    alignItems: "center",
    padding: 20,
    paddingLeft: 10,
    backgroundColor: "#fff",
    flexDirection: "row",
    height: 64,
    zIndex: 2,
  },
  animatedContainer: {
    zIndex: 1,
    position: "absolute",
    top: -10,
    left: 0,
    right: 0,
    paddingTop: 10,
    backgroundColor: "white",
  },
  headerContent: {
    alignItems: "flex-end",
    marginRight: 20,
    position: "absolute",
    right: 0,
    top: 10,
  },
  name: {
    fontSize: 24,
    fontFamily: "MontserratBold",
    lineHeight: 29,
    letterSpacing: 0,
    color: "#636E72",
    flex: 1,
  },
  nameHeader: {
    fontSize: 16,
  },
  city: {
    fontSize: 12,
    lineHeight: 12,
    letterSpacing: 0,
    color: "#636E72",
    marginTop: 0,
  },
  title: {
    color: "#636E72",
    fontSize: 20,
    // height: 24,
    lineHeight: 26,
    fontFamily: "MontserratBold",
    marginRight: 20,
  },
  menuContainer: {
    marginLeft: 15,
  },
  subText: {
    color: "#636E72",
    fontSize: 12,
  },
  backIcon: {
    height: 32,
    width: 32,
  },
  menuIcon: {
    height: 18,
    width: 18,
  },
  buttonLogin: {
    flexDirection: "row",
    height: 32,
    minWidth: undefined,
  },
  back: {
    color: "black",
    fontWeight: "400",
    fontSize: 12,
  },
  container: {
    flex: 1,
    marginHorizontal: 10,
  },
  right: {},
});

export default Header;
